module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '\n<a class="cta_item_container" href="' +
((__t = ( decode_utf8_link(link) )) == null ? '' : __t) +
'" target="' +
((__t = ( gon.display_options.ctaCurrentTab || gon.current_account.extra_fields.ctaCurrentTab ? '_parent' : '_blank')) == null ? '' : __t) +
'">\n\n	<div class="cta_holder">\n		<div class="cta_img" style="background-image:url(\'' +
((__t = ( decode_utf8(image) )) == null ? '' : __t) +
'\')" tabindex="0">\n			<img alt="' +
((__t = ( decode_utf8(altTextProduct(title)) )) == null ? '' : __t) +
'" src=\'' +
((__t = ( decode_utf8(image) )) == null ? '' : __t) +
'\' style="position: fixed; left: -100000px;"/>\n		</div>\n		<div class="product_right">\n			<div class="product_name">' +
((__t = ( decode_utf8(title) )) == null ? '' : __t) +
'</div>\n			<div class="product_cta">' +
((__t = ( decode_utf8(link_text) )) == null ? '' : __t) +
'</div>\n		</div>\n	</div>\n\n	';
 if (gon.display_options.reviewOptions && gon.display_options.reviewOptions.lightboxReviews){ ;
__p += '\n	<div class="review_holder"></div>\n	';
 } ;
__p += '\n</a>';

}
return __p
}